export type BiomeId = 'forest' | 'cave' | 'lava' | 'ice' | 'magical' | 'dungeon'

export interface BiomeTheme {
  id: BiomeId
  name: string
  ink: string
  surface: string
  surfaceRaised: string
  surfaceSunken: string
  edge: string
  biome: string
  biomeSoft: string
  ember: string
  emberDeep: string
}

export const EMBER = '#ffb454'
export const EMBER_DEEP = '#d97b2b'

export const BIOMES: Record<BiomeId, BiomeTheme> = {
  forest: {
    id: 'forest',
    name: 'Whispering Forest',
    ink: '#0c1712',
    surface: '#15271d',
    surfaceRaised: '#1d3527',
    surfaceSunken: '#0e1c15',
    edge: '#2f5740',
    biome: '#5fd38b',
    biomeSoft: '#8ee6ad',
    ember: EMBER,
    emberDeep: EMBER_DEEP,
  },
  cave: {
    id: 'cave',
    name: 'Echoing Caves',
    ink: '#0d0c16',
    surface: '#191826',
    surfaceRaised: '#242338',
    surfaceSunken: '#111020',
    edge: '#433f66',
    biome: '#9b8cff',
    biomeSoft: '#c0b6ff',
    ember: EMBER,
    emberDeep: EMBER_DEEP,
  },
  lava: {
    id: 'lava',
    name: 'Molten Reach',
    ink: '#160a08',
    surface: '#261210',
    surfaceRaised: '#381a16',
    surfaceSunken: '#1b0d0b',
    edge: '#6b2c22',
    biome: '#ff6a45',
    biomeSoft: '#ff9a7a',
    ember: EMBER,
    emberDeep: EMBER_DEEP,
  },
  ice: {
    id: 'ice',
    name: 'Glacier Hollow',
    ink: '#081218',
    surface: '#122430',
    surfaceRaised: '#1b3546',
    surfaceSunken: '#0c1a23',
    edge: '#2f6079',
    biome: '#5fd6ff',
    biomeSoft: '#a7ebff',
    ember: EMBER,
    emberDeep: EMBER_DEEP,
  },
  magical: {
    id: 'magical',
    name: 'Aurora Expanse',
    ink: '#130a18',
    surface: '#221530',
    surfaceRaised: '#331f45',
    surfaceSunken: '#180d22',
    edge: '#6a3a86',
    biome: '#e56aff',
    biomeSoft: '#f2a7ff',
    ember: EMBER,
    emberDeep: EMBER_DEEP,
  },
  dungeon: {
    id: 'dungeon',
    name: 'Sunken Dungeon',
    ink: '#100d09',
    surface: '#1f1a12',
    surfaceRaised: '#2d251a',
    surfaceSunken: '#15110c',
    edge: '#5c4a2e',
    biome: '#d0a24c',
    biomeSoft: '#e8c47f',
    ember: EMBER,
    emberDeep: EMBER_DEEP,
  },
}

export const BIOME_ORDER: BiomeId[] = ['forest', 'cave', 'lava', 'ice', 'magical', 'dungeon']

export function applyBiomeTheme(root: HTMLElement, id: BiomeId) {
  const t = BIOMES[id]
  root.style.setProperty('--ink', t.ink)
  root.style.setProperty('--surface', t.surface)
  root.style.setProperty('--surface-raised', t.surfaceRaised)
  root.style.setProperty('--surface-sunken', t.surfaceSunken)
  root.style.setProperty('--edge', t.edge)
  root.style.setProperty('--biome', t.biome)
  root.style.setProperty('--biome-soft', t.biomeSoft)
}
